export class DynamicCol {
  id: number;
  name: string;
  field?: string;
  width?: string;
  sortable?: boolean;
  internalOrder?: number;
}
